<template>
  <div>
    <vx-card class="mb-1">
      <vs-row vs-type="flex" vs-justify="space-between" >
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="6">         
              <label class="vs-input--label mr-2">Favorecido</label>              
              <vs-input class="mb-4 w-full" v-model="filtro.favorecido.nome" @keyup.enter="fetchLista(filtro)" />
          </vs-col>                    
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="3">       
            <label class="vs-input--label mr-2">Período</label>              
            <div class="flex items-center">
              <flat-pickr v-model="filtro.dataInicio" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" />
              <label class="vs-input--label mr-2">à</label>
              <flat-pickr v-model="filtro.dataFim" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
            </div>           
          </vs-col>             
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="3">       
              <label class="vs-input--label">Banco</label>                     
              <v-select                                               
                  :options="CONSTANTES_BANCO_HOMOLOGADOS" 
                  v-model="filtro.instituicao.numero"    
                  :clearable="false"
                  :reduce="r => r.data"     
                  style="z-index: 10000 !important;"                                                                    
                  class="v-select w-full">
              </v-select>  
          </vs-col>             
        
      </vs-row>
      <vs-row vs-type="flex" vs-justify="space-between" >
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6"> 
            <vs-checkbox class="w-full" v-model="filtro.ehSomenteSemRemessa"> Somente sem remessa </vs-checkbox>
            <vs-checkbox class="w-full" v-model="filtro.ehSomenteContasEmAberto"> Somente em aberto </vs-checkbox>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3" vs-justify="center">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-arrow-left" @click="setMes(false)"> </vs-button>
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-calendar" @click="setMesAtual"></vs-button>
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-arrow-right" @click="setMes(true)"> </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="3">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-search" title="Pesquisar" @click="fetchLista(filtro)"></vs-button>
            <vs-button class="mr-2" color="dark" type="border" icon-pack="feather" icon="icon-file" title="Limpar filtro" @click="limparFiltros"></vs-button>  
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-download" title="Gerar arquivo de remessa" @click="gerarArquivo" ></vs-button>          
            <vs-button color="rgb(11, 189, 135)" type="border" icon-pack="feather" icon="icon-save" title="Exportar" @click="exportarParaCSV"></vs-button>          
          </vs-col>
      </vs-row>

    </vx-card>
    <vs-alert color="danger" icon-pack="feather" closable close-icon="icon-x" class="mb-3" icon="icon-info" v-if="mensagemErro" >
                {{mensagemErro}}
        </vs-alert> 
    <div class="flex items-center mb-2 mt-2"> 
      <h6 class="ml-2 text-danger mr-4"> {{dadosDaGrid.length }} registros </h6>
      <vs-button v-if="dadosDaGrid.length > 1" class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-maximize" @click="selecionarTodas"> Selecionar Todos</vs-button>
      <vs-button v-if="dadosDaGrid.length > 1" color="warning" type="filled" icon-pack="feather" size="small" icon="icon-maximize" @click="deselecionarTodas"> Deselecionar Todos</vs-button>      
    </div>
    <vx-card class="mb-1">
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :rowHeight="25"
        :headerHeight="20"        
        rowSelection="multiple"
        rowMultiSelectWithClick="true"
        colResizeDefault="shift"        
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="false"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>      
    </vx-card>
    
  </div>

</template>

<script>
import { CONSTANTES_BANCO_HOMOLOGADOS } from '@/constantesComboBox.js'
import generico from '@/generico.js'
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'


export default {
  components: {
    AgGridVue,
    flatPickr
  },
  data() {
    return {
      filtro : {favorecido: {nome: null }, dataInicio:  null,dataFim : null, instituicao: {numero: '001'}, ehSomenteSemRemessa: true, ehSomenteContasEmAberto: true},
      configuracaoGrid: { 
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: '#', width: 20, maxWidth: 100, valueGetter: function(params) {return  params.node ? params.node.rowIndex + 1 : null }}, 
            { headerName: 'N', field: 'numeroLancamento', width: 20},                                   
            { headerName: 'CLIENTE', field: 'conta.favorecido.nome' },                      
            { headerName: 'VENCIMENTO', field: 'dataFormatada', width: 50},            
            { headerName: 'VALOR', field: 'VALOR', width: 40, 
               cellRenderer: function(params) { return generico.formatarMoedaReal(params.data.valor) }
            },                                                                                            
            { headerName: 'RECEITA', field: 'conta.contaPlanoConta.nome', width: 80},                                                                                            
            { headerName: 'BANCO', field: 'dataHoraIncluidoFormatado', width: 40, 
               cellRenderer: function(params) { return params.data.instituicao.nome + ' ' + params.data.instituicao.conta + '-' + params.data.instituicao.digitoConta }
            },
            { headerName: 'TIPO', field: 'tipo', width: 80},    
            { headerName: 'STATUS', field: 'status', width: 80},    
            { headerName: 'N. REMESSA', field: 'sequencialRemessa', width: 80},    
            { headerName: 'GERADA EM', field: 'dataGeracaoArquivoRemessa', width: 80},    
          ]
      },
      dadosDaGrid: [],
      totalRegistros: 0,
      configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
      },  
      numeroMesAtual: 0,
      mensagemErro: null
    }
  },  
  created(){
        this.CONSTANTES_BANCO_HOMOLOGADOS = CONSTANTES_BANCO_HOMOLOGADOS;
  }, 
  methods: {
    selecionarTodas(){
      this.configuracaoGrid.gridApi.selectAll();
    },
    deselecionarTodas(){
      this.configuracaoGrid.gridApi.deselectAll();
    },
    setMes(incrementar){
      
      if (incrementar) {
        this.numeroMesAtual = this.numeroMesAtual + 1;
      } else {
        this.numeroMesAtual = this.numeroMesAtual - 1;
      }

      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth() + this.numeroMesAtual, 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1 + this.numeroMesAtual, 0);

      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
    },
    setMesAtual(){
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
      this.numeroMesAtual = 0;
    },
    limparFiltros() {
      this.filtro = {favorecido: {nome: null }, dataInicio:  null,dataFim : null};
    },
    fetchLista() {     
      this.mensagemErro = null;        
      this.$vs.loading() 
      const params = new URLSearchParams();
      params.append('pagina', -1);
      
      if (this.filtro.favorecido.nome) {
        params.append('conta.favorecido.nome', this.filtro.favorecido.nome);
      }

      if(this.filtro.dataInicio != null){
        params.append("dataInicio", this.filtro.dataInicio);
      }
      
      if(this.filtro.dataFim != null){
        params.append("dataFim", this.filtro.dataFim);
      }

      if (this.filtro.instituicao.numero) {
        params.append('instituicao.numero', this.filtro.instituicao.numero);
      }
      params.append('ehSomenteSemRemessa', this.filtro.ehSomenteSemRemessa);
      params.append('ehSomenteContasEmAberto', this.filtro.ehSomenteContasEmAberto);
      
      axios.post("/Lancamento/ListarLancamentoRemessa", params, {   
              headers: {'Accept': 'application/json' },           
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/' });
          } else {
            this.totalRegistros = response.data.Resultado.quantidade;              
            this.dadosDaGrid = response.data.Resultado.lista;              
            this.configuracaoGrid.gridApi.sizeColumnsToFit();   
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'Remessa.csv'};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    },

    getPrefixoArquivoRemessa() {
     return generico.getDataHoraYYYYMMDDHHMMSS();      
    },
    getNomeArquivoRemessa() {
      var currentDateTime = new Date();
      let nomeArquivo = "";
      
      if (this.filtro.instituicao.numero === "748") {        
        if (parseInt(currentDateTime.getMonth + 1) === 10) {
          nomeArquivo = "O"
        } else if (parseInt(currentDateTime.getMonth + 1) === 11) {
          nomeArquivo = "N";
        } else if (parseInt(currentDateTime.getMonth + 1) === 12) {
          nomeArquivo = "D";
        }

        nomeArquivo = nomeArquivo + generico.zeroPad(currentDateTime.getDate(), 2);
        nomeArquivo = this.dadosDaGrid[0].instituicao.conta + nomeArquivo; 
      } else {        
        nomeArquivo = generico.getDataHoraMMddhhmm();
      }
      
      return nomeArquivo;
    },
    gerarArquivo() {
      if (this.configuracaoGrid.gridApi && this.configuracaoGrid.gridApi.getSelectedRows() && this.configuracaoGrid.gridApi.getSelectedRows().length) {
          let mensagem = 'Deseja gerar o arquivo de remessa de ' + this.configuracaoGrid.gridApi.getSelectedRows().length + ' lançamentos ?';
          if (this.filtro.instituicao.numero === '403') {
            mensagem = 'Deseja enviar para o CORA ' + this.configuracaoGrid.gridApi.getSelectedRows().length + ' lançamentos ?';
          } 
          this.$vs.dialog({
            type: 'confirm', color: 'warning', title: 'Atenção', text: mensagem, acceptText: 'Sim', cancelText: 'Não', accept: this.gerarArquivoRequest
          });
      } else {
        this.$vs.notify({
            title: "Erro", iconPack: 'feather', icon: 'icon-alert', color: 'danger', text: 'Selecione pelo meno um item' });
      }
    },
    gerarArquivoRequest() {        
        this.mensagemErro = null;        
        var listIds = null;

        var selectedRows = this.configuracaoGrid.gridApi.getSelectedRows();
        selectedRows.forEach(function(selectedRow) {            
            if (listIds === null) {
                listIds = new String();
                listIds = listIds + selectedRow.id;
            } else {
                listIds = listIds + "," + selectedRow.id;
            }
        });       

        this.$vs.loading();
        const params = new URLSearchParams();                
        params.append('idUsuario', String(this.$store.state.AppActiveUser.id));        
        params.append('listaIds', listIds);  
        params.append('sequencialRemessa', this.getPrefixoArquivoRemessa());  
        let nomeArquivo = this.getNomeArquivoRemessa();

        if (this.filtro.instituicao.numero === "748") {
          nomeArquivo = nomeArquivo + ".CRM";
        } else {
          nomeArquivo = nomeArquivo + ".rem";
        }
        params.append('nomeArquivoDownload', nomeArquivo);                       
        params.append('numeroInstituicao', this.filtro.instituicao.numero);

        // Configuração diferente para instituição 403
        let requestConfig = {
            timeout: 600000, 
            credentials: 'include', 
            withCredentials: true
        };
        
        // Para instituição 403, não usar arraybuffer
        if (this.filtro.instituicao.numero !== '403') {
            requestConfig.responseType = 'arraybuffer';
            requestConfig.responseEncoding = 'iso88591';
        }
                
        axios.post("/Lancamento/GerarArquivoRemessa", params, requestConfig )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                
                  this.$router.push({ path: '/login' });  // Efetuar logoff
            } else {                            
                if (this.filtro.instituicao.numero === '403') {
                  this.mensagemErro = response.data;                  
                } else {                                                                    
                  var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                  var fileLink = document.createElement('a');
                  fileLink.href = fileURL;
                  fileLink.setAttribute('download', nomeArquivo);
                  document.body.appendChild(fileLink);
                  fileLink.click();                
                }
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
            this.$vs.loading.close();
            this.$vs.notify({ title: "Erro",  iconPack: 'feather',  icon: 'icon-alert-triangle',  color: 'danger',  text: 'Erro ao processar solicitação. Tente novamente.'});
        }) 
    },
    
  },
  mounted() {
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;
    this.configuracaoGrid.gridApi.sizeColumnsToFit();   

    if (this.$store.getters.filtroItemContaFuturo) {
        this.filtro = JSON.parse(JSON.stringify(this.$store.getters.filtroItemContaFuturo));
    } else {
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
    }       
  },
  beforeDestroy() {    
    //this.$store.dispatch('setarFiltro', {nomeTela: 'itemContaFuturo' , filtro: this.filtro});
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 310px);
  }
</style>
